import { CompanyChartData } from 'lib/entities/company.types';
import { useMemo } from 'react';
import { CoreChartOptions } from 'chart.js';
import ChartDetail from './ChartDetail';
import MainChart from './MainChart';
import { ChartWrapper } from './styled';
import { ChartTimeFrames } from '../constants.types';
import { CompanyOrderbook } from '../../../../@types/orderbook';

interface ChartV2Props {
  symbol: string;
  company: any;
  isLoadingChart?: boolean;
  chart: CompanyChartData;
  timeframe: ChartTimeFrames;
  isChartVisible?: boolean;
  onSelectTimeFrame?: (v: ChartTimeFrames) => void;
  onExpand: () => void;
  onClickChart?: CoreChartOptions<'line'>['onClick'];
  disableChartbitLink?: boolean;
}

function ChartV2({
  symbol = '',
  company,
  isLoadingChart,
  chart,
  timeframe,
  isChartVisible,
  onSelectTimeFrame,
  onExpand,
  onClickChart,
  disableChartbitLink,
}: ChartV2Props) {
  const showDetail = useMemo(() => {
    const whitelistSectors = [
      'index asing',
      'commodities',
      'fx',
      'crypto',
      'index',
      'reksadana',
      'waran',
      'etf',
      'right',
    ];
    // Pass if sector is whitelisted
    if (whitelistSectors.includes(company?.type_company?.toLowerCase())) {
      return true;
    }

    return !!chart;
  }, [chart, company]);

  return (
    <ChartWrapper as="section">
      {showDetail && (
        <ChartDetail
          timeframe={timeframe}
          showTimeframes={isChartVisible}
          symbol={symbol}
          onExpand={onExpand}
          company={company}
          chart={chart}
          onSelectTimeframe={onSelectTimeFrame}
        />
      )}
      <MainChart
        timeframe={timeframe}
        showTimeframes={showDetail}
        symbol={symbol}
        onSelectTimeframe={onSelectTimeFrame}
        visible={isChartVisible}
        isLoadingChart={isLoadingChart}
        chart={chart}
        onClickChart={onClickChart}
        disableChartbitLink={disableChartbitLink}
      />
    </ChartWrapper>
  );
}

export default ChartV2;
